// extracted by mini-css-extract-plugin
export var ContactModal = "contactModal-module--ContactModal--11fA-";
export var buttonClose = "contactModal-module--buttonClose--10By1";
export var contactsList = "contactModal-module--contactsList--1QsRH";
export var contactItem = "contactModal-module--contactItem--21DQr";
export var icon = "contactModal-module--icon--S5Qao";
export var contactLink = "contactModal-module--contactLink--3PQCB";
export var orderServiceButton = "contactModal-module--orderServiceButton--1yAuq";